import React, { useEffect, useState } from "react";
import "../components/WetaOrderList.css";
import { FaEye } from "react-icons/fa";

const WetaOrderList = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const response = await fetch("https://wetaworldz.com/api/order-list", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            // "Authorization": "Bearer YOUR_TOKEN" if required
          },
        });

        const data = await response.json();
        console.log("API Response:", data); // Check API output
        setOrders(data.orderData || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching orders:", error);
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);
const handleDelete = async (orderId) => {
  if (!window.confirm("Are you sure you want to delete?")) return;

  try {
    const formData = new FormData();
    formData.append("order_id", orderId);

    const response = await fetch("https://wetaworldz.com/api/order-list-update", {
      method: "POST",
      body: formData,
    });

    const text = await response.text();
    console.log("RAW RESPONSE:", text);

    let result;
    try {
      result = JSON.parse(text);
    } catch (err) {
      alert("Server error: not JSON response");
      return;
    }

    // ✅ FIXED CONDITION
    if (result.status === "success") {
      alert(result.message || "Deleted successfully");

      setOrders((prev) =>
        prev.filter((item) => item.order_id !== orderId)
      );
    } else {
      alert(result.message || "Delete failed");
    }

  } catch (error) {
    console.error("Delete error:", error);
    alert("Something went wrong!");
  }
};
  if (loading) return <p>Loading orders...</p>;

  return (
    <div className="order-container">
      <div className="header-bar">
        <h2>Weta Worldz : New Order List</h2>
      </div>

      <table className="order-table">
        <thead>
          <tr>
            <th>No</th>
            <th>Order By</th>
            <th>Order No</th>
            <th>Order Date</th>
            <th>Amount (₹)</th>
            <th>Payment Status</th>
            {/* <th>Payment Type</th> */}
            <th>Order Status</th>
            <th>Coupon</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {orders.length === 0 ? (
            <tr>
              <td colSpan="10" style={{ textAlign: "center" }}>
                No orders found.
              </td>
            </tr>
          ) : (
            orders.map((order, index) => (
              <tr key={order.order_id}>
                <td>{index + 1}</td>
                <td>{order.order_name || "-"}</td>
                <td>{order.order_no || "-"}</td>
                <td>{order.order_date || "-"}</td>
                <td>{order.order_grandtotal ? order.order_grandtotal.toFixed(2) : "-"}</td>
                <td>
                  <span
                    className={`status ${
                      order.order_payment_status ? order.order_payment_status.toLowerCase() : ""
                    }`}
                  >
                    {order.order_payment_status || "-"}
                  </span>
                </td>
                {/* <td>{order.order_payment_type || "-"}</td> */}
                <td>
                  <span
                    className={`status ${
                      order.order_deliver_status ? order.order_deliver_status.toLowerCase() : ""
                    }`}
                  >
                    {order.order_deliver_status || "-"}
                  </span>
                </td>
                <td>{order.order_coupon_code || "-"}</td>
                <td>
  <button
    className="btn-delete"
    onClick={() => handleDelete(order.order_id)}
  >
    Delete
  </button>
</td>
                {/* <td>
                  <button className="btn-view">
                    <FaEye /> View
                  </button>
                </td> */}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default WetaOrderList;
